"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBadgeComponentMap = void 0;
var BadgeText_1 = require("../components/Atoms/BadgeText");
var BadgePill_1 = require("../components/Atoms/BadgePill");
var BadgeRectangle_1 = require("../components/Atoms/BadgeRectangle");
var BadgeImage_1 = require("../components/Atoms/BadgeImage");
exports.defaultBadgeComponentMap = {
    BadgeText: function () { return BadgeText_1.BadgeText; },
    BadgePill: function () { return BadgePill_1.BadgePill; },
    BadgeRectangle: function () { return BadgeRectangle_1.BadgeRectangle; },
    BadgeImage: function () { return BadgeImage_1.BadgeImage; },
};
